import { Observable } from 'rxjs';
import { BaseController } from '~client/controller/base-controller';
import { LiveConferenceInfoResponse } from '~client/model/live-conference-info-response';
import { ClientUpdateLiveConferenceConfigRequest } from '~client/model/client-update-live-conference-config-request';
import { LiveConferenceConfigResponse } from '~client/model/live-conference-config-response';
import { ResponseEntity } from '~client/model/response-entity';
import {
  CreateLiveConferenceCandidatesRequest,
  CreateLiveConferenceCandidatesResponse,
  DeleteLiveConferenceCandidatesRequest,
  LiveConferenceCandidatesResponse,
} from '~client/model/live-conference-candidates';

/* Admin APIs pertaining to managing live conference */
export class LiveConferenceClientController extends BaseController {
  /** Returns the live conference info for an event. */
  public getClientLiveConferenceInfo$(eventId: string): Observable<LiveConferenceInfoResponse> {
    return this.get$('/client/streaming/conference', { eventId });
  }

  /** Updates the live conference info for an event. */
  public updateEventLiveConferenceConfig$(
    liveConferenceConfig: ClientUpdateLiveConferenceConfigRequest,
  ): Observable<LiveConferenceConfigResponse> {
    return this.put$('/client/streaming/conference/config', liveConferenceConfig);
  }

  /** Gets the list of users who are currently participating in the live conference. */
  public getClientLiveConferenceCandidates$(
    eventId: string,
  ): Observable<LiveConferenceCandidatesResponse> {
    return this.get$('/client/streaming/conference/candidates', { eventId });
  }

  /** Force invites participants to the live conference. */
  public createLiveConferenceCandidates$(
    request: CreateLiveConferenceCandidatesRequest,
  ): Observable<CreateLiveConferenceCandidatesResponse> {
    return this.post$('/client/streaming/conference/candidates', request);
  }

  /** Deletes specific participants to the live conference. */
  public deleteLiveConferenceCandidates$(
    request: DeleteLiveConferenceCandidatesRequest,
  ): Observable<ResponseEntity> {
    return this.del$('/client/streaming/conference/candidates', null, { data: request });
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src891534606/src/modules/client/src/controller/live-conference-client-controller.ts